import { IS_USE_CENTIMETERS_SIZE_COUNTRY } from '@/constants/is-use-centimeters-size-country';
import { sizeMap } from '@/constants/size-map';
import { WebsiteEnv } from '@/constants/website-env';
import { gql, useQuery } from '@apollo/client';
import { useMemo } from 'react';
import classes from './sizeChart.module.css';

export const GET_CMS_BLOCKS = gql`
  query cmsBlocks($identifiers: [String]!) {
    cmsBlocks(identifiers: $identifiers) {
      items {
        content
        identifier
      }
    }
  }
`;

function escape2Html(str) {
  const arrEntities = {
    lt: '<',
    gt: '>',
    nbsp: ' ',
    amp: '&',
    quot: '"',
  };

  return str?.replace(/&(lt|gt|nbsp|amp|quot);/gi, function (all, t) {
    return arrEntities[t];
  });
}

const selectsizeMap = {
  S6: '6',
  HS6: '6.5',
  S7: '7',
  HS7: '7.5',
  S8: '8',
  HS8: '8.5',
  S9: '9',
  HS9: '9.5',
  S10: '10',
  HS10: '10.5',
  S11: '11',

  6: '6',
  H6: '6.5',
  7: '7',
  H7: '7.5',
  8: '8',
  H8: '8.5',
  9: '9',
  H9: '9.5',
  10: '10',
  H10: '10.5',
  11: '11',
  H11: '11.5',
};

const SizeChartNoFlash = props => {
  const { showAttribute, sizeLabel, selectedValue, sizechartdialog } = props;
  const selectsize = selectedValue?.default_label;
  const blockName = showAttribute?.find(item => item.code == 'product_size_chart')?.value?.split(', ');
  const identifiers = blockName?.[0] || '';
  const { loading, data } = useQuery(GET_CMS_BLOCKS, {
    variables: {
      identifiers,
    },
    skip: !identifiers,
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-and-network',
  });
  const { items } = data?.cmsBlocks || {};
  const content = items?.[0]?.content || '';

  const processedHtml = useMemo(() => {
    if (!content) {
      return '';
    }

    const tempDiv = document.createElement('div');

    try {
      tempDiv.innerHTML = escape2Html(decodeURI(content.replace(/%/g, '%25')).split('sizechartpartition')[0]);
    } catch (error) {
      console.error('解析内容时出错:', error);

      return '';
    }

    const applyLogic = () => {
      // 使用tempDiv而不是document
      const women = tempDiv.querySelector('.women tbody');
      const men = tempDiv.querySelector('.men tbody');
      const trElement = tempDiv.querySelector('.sizetabcon thead tr.hidden');

      if (trElement) {
        trElement.classList.remove('hidden');
      }

      let allsizedata = women || men || tempDiv.querySelector('.sizetabcon tbody');

      if (sizeLabel === "Women's Size") {
        allsizedata = women || allsizedata;
      } else {
        allsizedata = men || allsizedata;
      }

      const allsizedatatr = allsizedata?.getElementsByTagName('tr') || [];

      // 先将所有行设置为隐藏
      Array.from(allsizedatatr).forEach(row => {
        if (WebsiteEnv.isUnitedKingdom || WebsiteEnv.isAustralia || WebsiteEnv.isIreland || WebsiteEnv.isNewZealand) {
          const tds = row.getElementsByTagName('td');
          tds[0].textContent = sizeMap[tds[0].textContent] || tds[0].textContent;
        }

        if (IS_USE_CENTIMETERS_SIZE_COUNTRY) {
          const tds = row.getElementsByTagName('td');
          Array.from(tds).forEach((td, index) => {
            if (index === 0) return;

            let sizeNumber = td.textContent;
            sizeNumber = sizeNumber.replaceAll('½', '.5').replaceAll('¼', '.25').replaceAll('¾', '.75');
            sizeNumber = parseFloat(sizeNumber);
            sizeNumber = (sizeNumber * 2.54).toFixed(1);
            td.textContent = `${sizeNumber}cm`;
          });
        }

        row.classList.add('hidden');
      });

      Array.from(allsizedatatr).forEach((currentRow, i) => {
        const allsizedatatd = currentRow.getElementsByTagName('td');

        if (allsizedatatd.length === 0) {
          return;
        }

        const chosenCurrentTR =
          allsizedatatd[0].innerHTML === selectsize || allsizedatatd[0].innerHTML === selectsizeMap[selectsize];

        currentRow.classList.remove('highlight');

        if (chosenCurrentTR) {
          currentRow.classList.remove('hidden');
          currentRow.classList.add('highlight');

          // 显示当前行和相邻行
          if (i > 0) {
            allsizedatatr[i - 1]?.classList.remove('hidden');
          }

          if (i < allsizedatatr.length - 1) {
            allsizedatatr[i + 1]?.classList.remove('hidden');
          }
        }
      });

      return tempDiv.innerHTML;
    };

    try {
      return applyLogic();
    } catch (error) {
      console.error('应用逻辑时出错:', error);

      return '';
    }
  }, [content, selectsize, sizeLabel]);

  if (!blockName) {
    return null;
  }

  if (loading) {
    return null;
  }

  if (!selectsize) {
    return null;
  }

  if (selectsize === 'customized_size') {
    return null;
  }

  return (
    <div
      className={classes.sizechart}
      dangerouslySetInnerHTML={{
        __html: processedHtml,
      }}
    />
  );
};

export default SizeChartNoFlash;
